import { defineComponent, onBeforeUnmount, onMounted, type PropType, ref } from "vue";
import { assert } from "@utils/assertion";
import Tooltip from "bootstrap/js/dist/tooltip";

export const GaTooltip = defineComponent({
  props: {
    title: {
      type: String,
      required: true,
    },
    placement: {
      type: String as PropType<Tooltip.PopoverPlacement>,
      required: false,
    },
    htmlEnabled: {
      type: Boolean,
      required: false,
    },
    wide: {
      type: Boolean,
      required: false,
    },
  },
  setup(props, { slots }) {
    const wrapperEl = ref<HTMLElement | null>(null);
    let tooltipInstance: Tooltip | null = null;
    onMounted(() => {
      assert(wrapperEl.value !== null, "wrapperEl not expected be null");
      tooltipInstance = new Tooltip(wrapperEl.value, {
        title: props.title,
        html: props.htmlEnabled,
        placement: props.placement ?? "top",
        customClass: props.wide ? "tooltip-wide" : "",
      });
    });

    onBeforeUnmount(() => {
      tooltipInstance?.dispose();
    });
    return () => <span ref={wrapperEl}>{slots.default?.()}</span>;
  },
});
